import classNames from "classnames";
import styles from "./AscSharingCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import AscButton from "../../AscButton/AscButton";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscLink from "../../AscLink/AscLink";
dayjs.extend(relativeTime);

export interface AscFiltersCardProps {
  className?: string;
  loading?: boolean;
  isButtonDisabled?: boolean;
  onDownloadClick?: () => void;
  onShareClick?: () => void;
  onLinkClick?: () => void;
}

export default function AscSharingCard({
  className,
  loading,
  onDownloadClick,
  onShareClick,
  onLinkClick,
  isButtonDisabled
}: AscFiltersCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title="Sharing"
      coverImageUrl={null}
      loading={loading}
    >
      <div className={styles.buttons}>
        <AscButton disabled={isButtonDisabled} size="large" onClick={onDownloadClick}>
          Download
        </AscButton>
        {/* temporary hiding */}
        {/* <AscButton size="large" onClick={onShareClick}>
          Share
        </AscButton> */}
      </div>
       {/* temporary hiding */}
      {/* <div className={styles.texts}>
        <AscParagraph className={styles.primary}>
          Have you changed your name?
        </AscParagraph>
        <AscLink onClick={onLinkClick} className={styles.link}>
          Update your certificate
        </AscLink>
      </div> */}
    </AscGenericCard>
  );
}
